import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IBookmark } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { bookmarkColumns } from "./components/bookmarkColumns";
import { bookmarkSearchFields } from "./components/bookmarkSearchFields";

export const BookmarkList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IBookmark>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="사용자별 북마크 현황"
            />

            <SearchToolbar
                fields={bookmarkSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={bookmarkColumns}
                isError={tableQueryResult.isError}
                errorMessage="북마크 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 북마크가 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
            />
        </List>
    );
};
